import { render } from "./PendingBankDeposit.vue?vue&type=template&id=7f8fa583&ts=true"
import script from "./PendingBankDeposit.vue?vue&type=script&lang=ts"
export * from "./PendingBankDeposit.vue?vue&type=script&lang=ts"

import "./PendingBankDeposit.vue?vue&type=style&index=0&id=7f8fa583&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/PendingBankDeposit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f8fa583"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f8fa583', __exports__)) {
    api.reload('7f8fa583', __exports__)
  }
  
  module.hot.accept("./PendingBankDeposit.vue?vue&type=template&id=7f8fa583&ts=true", () => {
    api.rerender('7f8fa583', render)
  })

}


export default __exports__